module.exports = __webpack_public_path__ + "media/images/sp/stores/hiroshima/hiroshima_concept_01-c1677ff8f29c411f8dbf676e32e3678f.jpg";